import script from "./DiscussionPost.vue?vue&type=script&setup=true&lang=ts"
export * from "./DiscussionPost.vue?vue&type=script&setup=true&lang=ts"

import "./DiscussionPost.vue?vue&type=style&index=0&id=318fb7d3&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src669166032/src/hackingclub-spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-318fb7d3"]])

export default __exports__